import { useLocation } from 'react-router';
import { Typography } from '@mui/material';

import { CasErrorDisplay } from 'src/compass/shared/components';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import { useCurrentUserEmployee } from 'src/compass/application';

import UnassignedTouchpointsTable from './UnassignedTouchpointsTable';

export default function UnassignedTab() {
  const { data, isLoading, isError } = useCurrentUserEmployee();
  const location = useLocation();

  if (isLoading) return <CasLoader />;
  if (isError) return <CasErrorDisplay message="Error receiving CurrentUser/RiskManager" />;

  return (
    <>
      {location.state?.autoNavigated && (
        <Typography variant="body1" className="auto-refresh-text">
          You have entities with unassigned Frequencies
        </Typography>
      )}
      <UnassignedTouchpointsTable employeeId={data?.employeeId} />
    </>
  );
}
